import OnDemandDevelopers from "../../on-demand-developers";
import ProjectByEquity from "../../project-by-equity";
import FullProjectDevelopment from "../../full-project-development";
import WhatServices from "../../what-services";
import Confirmation from "../../confirmation";
import NavBar from "../../nav-bar";
import OurServices from "../../our-services";
import Grid from "@mui/material/Grid/Grid";
import {CustomLabelMediumBold, CustomLabelMediumRegular} from "../../common/CustomLabel";
import Box from "@mui/material/Box/Box";
import IPHONE151 from "../../../assets/images/iPhone 15 Pro-1.png";
import ContactUs from "../../contact-us";
import Footer from "../../footer";
import React, {useRef, useState} from "react";
import {useMediaQuery} from "@mui/material";
import createTheme from "@mui/material/styles/createTheme";
import IntroDetails from "../../intro-details";
import IPHONE15 from "../../../assets/images/ostryx-lap.png";
import { useNavigate} from "react-router-dom"
import Paper from "@mui/material/Paper/Paper";
import SeeOurWork from "src/components/see-our-work";
import ToolsWeUSe from "src/components/services-detail/tools-use-section"
import ProcessSection from "src/components/services-detail/process-section";

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 710,
            md: 950,
            lg: 1300,
            xl: 1350,
        },
    },
});

// Carousel settings for react-slick
var settings_our_work = {
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true, 
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    adaptiveHeight: true,
    cssEase: "linear",  // Add smooth transition
    swipeToSlide: true, // Enable swipe to slide
    responsive: [
        {
            breakpoint: 1300,
            settings: {
                slidesToShow: 2,  // Changed from 2.5 to 2
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,  // Changed from 2.5 to 2
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 700,
            settings: {
                slidesToShow: 1,  // Changed from 1.5 to 1
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,  // Changed from 1.2 to 1
                slidesToScroll: 1,
            },
        },
    ],
};

const ServicesDetails = ({}) => {

    const [isMenuClicked, setIsMenuClicked] = useState(false)

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [showFullProject, setShowFullProject] = useState(false);
    const [showOnDemandDevelopers, setShowOnDemandDevelopers] = useState(false);
    const [showProjectByEquity, setShowProjectByEquity] = useState(false);
    const [showWhatServices, setShowWhatService] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);

    let navigate = useNavigate();


    const serviceRef = useRef(null);
    const portfolioRef = useRef(null);
    const testimonalsRef = useRef(null);
    const partnersRef = useRef(null);
    const contactUsRef = useRef(null);



    return (
        <Grid style={{width: "100vw", height: "100vh", overflowX: "hidden",}}>

            {
                showOnDemandDevelopers && <OnDemandDevelopers setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                                                              setShowConfirmation={setShowConfirmation}
                />
            }

            {
                showProjectByEquity && <ProjectByEquity setShowProjectByEquity={setShowProjectByEquity}
                                                        setShowConfirmation={setShowConfirmation}/>
            }


            {
                showFullProject && <FullProjectDevelopment setShowFullProject={setShowFullProject}
                                                           setShowConfirmation={setShowConfirmation}/>
            }


            {
                showWhatServices &&
                <WhatServices setShowWhatService={setShowWhatService} setShowFullProject={setShowFullProject}
                              setShowProjectByEquity={setShowProjectByEquity}
                              setShowOnDemandDevelopers={setShowOnDemandDevelopers}/>
            }


            {
                showConfirmation && <Confirmation setShowConfirmation={setShowConfirmation}/>
            }
            <Grid >
                <Box sx={{ position: 'relative', zIndex: 2 }}>
                    <NavBar 
                        isMenuClicked={isMenuClicked}
                        serviceRef={serviceRef}
                        portfolioRef={portfolioRef}
                        testimonalsRef={testimonalsRef}
                        partnersRef={partnersRef}
                        setIsMenuClicked={setIsMenuClicked}
                        contactUsRef={contactUsRef}
                        setShowWhatService={setShowWhatService}
                    />
                </Box>
            </Grid>
            

            <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}}} justifyContent={"center"}>

                
            <Grid item container justifyContent={"space-between"}
                  sx={{padding: {xs: "0px 10px", md: "0px 40px"}, marginTop: {xs: "10px", md: "40px"}}}>

                <Grid item xs={12} sx={{display: {xs: 'flex', lg: 'none'}}}>
                    <img src={IPHONE15} style={{width: "100%"}} alt={"OSTRYX"} />
                </Grid>


                    <Grid item xs={12} lg={5.8} sx={{marginTop: {xs: "20px", lg: "0px"}}}>
                            <Grid item
                                sx={{padding: {xs:"10px",md:"20px 20px"}}}>
                                <Grid item container sx={{marginTop: {xs: "20px", md: "50px"}}}>
                                        <CustomLabelMediumBold text={"GRAPHIC DESIGN"} color={"#5E17EB"}/>
                                </Grid> 
                                <Grid item container>
                                        <CustomLabelMediumBold text={"Crafting Exceptional User Experiences"}/>
                                </Grid> 
                                <Grid item container style={{marginTop: "10px"}}>
                                    <CustomLabelMediumRegular
                                        normal={true}
                                        text={"A product’s success starts with how users feel when they interact with it. Our UI/UX team creates intuitive, engaging, and user-friendly designs that turn first-time visitors into loyal users."}
                                    >
                                    </CustomLabelMediumRegular>
                                </Grid>

                            </Grid>
                    </Grid>


                    <Grid item xs={4.8} 
                        sx={{
                            marginTop : "50px",
                            // maxHeight: "100%",
                            // width: "100%",
                            marginRight: "100px",
                            // position: "relative",
                            // display: {xs: 'none', lg: 'flex'}
                        }}>
                        <Grid container justifyContent={"center"}>
                            <img src={IPHONE15} style={{
                                borderRadius : 40,
                                // position: "absolute",
                                // top: 80,
                                height: "100%",
                                maxWidth: "100%",
                                width: {lg: "100%", xlg: "auto"}
                            }} alt={"OSTRYX"}/>

                        </Grid>
                    </Grid>

                </Grid>
            </Grid> 

            <ProcessSection/>

            <ToolsWeUSe/>  

            <SeeOurWork portfolioRef={portfolioRef} settings_our_work={settings_our_work}/>

            <OurServices serviceRef={serviceRef} setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                         setShowWhatService={setShowWhatService}
                         setShowFullProject={setShowFullProject}
                         setShowProjectByEquity={setShowProjectByEquity}/>


            <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}, px :{ xs: 1, md: 5}}} justifyContent={"center"}>

                <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "50px"}}}>
                    <CustomLabelMediumBold text={"Discuss Your Project with #1 Software Development Company USA "} color={"#5E17EB"}/>
                </Grid>

                <Grid item container xs={10} style={{marginTop: "5px"}} justifyContent={"center"}>
                    <CustomLabelMediumRegular normal={false}
                                              text={"HGot an Idea? Let’s Build It Together — Contact Us for Expert Development Solutions.  "}
                    />
                </Grid>


                <Grid item container xs={12} justifyContent={"space-between"}
                      sx={{padding: {xs: "0px 10px", md: "0px 40px"}, marginTop: {xs: "20px", lg: "60px"}}}>


                    <Grid item xs={12} lg={4.8}
                          sx={{maxHeight: "100%", width: "100%", padding: "0px", position: "relative"}}>
                        <Box component={"img"} src={IPHONE151} alt={"OSTRYX"}
                             sx={{height: {lg: "100%"}, width: {xs: "100%", lg: "100%", xlg: "auto"}}}/>
                    </Grid>

                    <ContactUs setShowConfirmation={setShowConfirmation}/>


                </Grid>

                <div ref={contactUsRef} tabIndex={0}></div>

            </Grid>


            <Footer/>

        </Grid>
    )
}

export default ServicesDetails;
